import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69e94482"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  props: {
    iconUrl: null,
    handler: null
  },
  setup(__props: any) {

const props = __props as {
  iconUrl: string,
  handler?: (e: MouseEvent) => void
}



const iconStyle = computed(() => {
  if (props.iconUrl) {
    return {
      backgroundImage: `url(${props.iconUrl})`
    };
  } else {
    return '';
  }
});

function onClick (e: MouseEvent) {
  props.handler && props.handler(e);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "icon",
    style: _normalizeStyle(_unref(iconStyle)),
    onClick: _withModifiers(onClick, ["stop"])
  }, null, 12, _hoisted_1))
}
}

})